import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NewTariffDetail from "../NewTariffDetail/NewTariffDetail";
import { getTariffs } from "../../../redux/actions/tariff/getTariffs";

const NewTariff = () => {
  const dispatch = useDispatch();
  const {
    getTariffs: { data: tariffsData, loading, error },
  } = useSelector((state) => state.tariff);

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    dispatch(getTariffs());
  }, [dispatch]);

  useEffect(() => {
    // Set first tariff as selected when data is loaded
    if (tariffsData && tariffsData.length > 0 && !selectedOption) {
      setSelectedOption(tariffsData[0].name);
    }
  }, [tariffsData, selectedOption]);

  if (loading) {
    return (
      <div className="tw-min-h-screen tw-bg-gradient-to-br tw-from-slate-50 tw-to-blue-50 tw-p-6 tw-flex tw-items-center tw-justify-center">
        <div className="tw-text-xl tw-text-gray-600">Загрузка тарифов...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tw-min-h-screen tw-bg-gradient-to-br tw-from-slate-50 tw-to-blue-50 tw-p-6 tw-flex tw-items-center tw-justify-center">
        <div className="tw-text-xl tw-text-red-600">
          Ошибка загрузки тарифов
        </div>
      </div>
    );
  }

  if (!tariffsData || tariffsData.length === 0) {
    return (
      <div className="tw-min-h-screen tw-bg-gradient-to-br tw-from-slate-50 tw-to-blue-50 tw-p-6 tw-flex tw-items-center tw-justify-center">
        <div className="tw-text-xl tw-text-gray-600">Нет доступных тарифов</div>
      </div>
    );
  }

  const activeItem = tariffsData.find((item) => item.name === selectedOption);
  return (
    <div className="tw-min-h-screen tw-bg-gradient-to-br tw-from-slate-50 tw-to-blue-50 tw-p-6">
      <div className="tw-max-w-7xl tw-mx-auto">
        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-8 tw-items-start">
          {/* Tariff Selection Cards */}
          <div className="tw-w-full lg:tw-w-2/5 tw-space-y-4">
            {tariffsData.map((item, index) => (
              <div
                key={item.name}
                className={`tw-relative tw-cursor-pointer tw-transition-all tw-duration-300 tw-transform hover:tw-scale-[1.02] ${
                  selectedOption === item.name
                    ? "tw-ring-4 tw-ring-blue-500 tw-ring-opacity-50 tw-shadow-xl"
                    : "tw-hover:tw-shadow-lg"
                }`}
                onClick={() => setSelectedOption(item.name)}
              >
                <label className="tw-flex tw-items-center tw-justify-between tw-p-6 tw-bg-white tw-rounded-2xl tw-border-2 tw-border-gray-200 tw-cursor-pointer">
                  <div className="tw-flex tw-items-center tw-space-x-4">
                    <div className="tw-relative">
                      <input
                        type="radio"
                        name="option"
                        value={item.name}
                        checked={selectedOption === item.name}
                        onChange={(e) => setSelectedOption(e.target.value)}
                        className="tw-w-5 tw-h-5 tw-text-blue-600 tw-border-2 tw-border-gray-300 focus:tw-ring-blue-500 focus:tw-ring-2"
                      />
                      {selectedOption === item.name && (
                        <div className="tw-absolute tw-inset-0 tw-w-5 tw-h-5 tw-bg-blue-600 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                          <div className="tw-w-2 tw-h-2 tw-bg-white tw-rounded-full"></div>
                        </div>
                      )}
                    </div>

                    <div>
                      <h3 className="tw-text-xl tw-font-bold tw-text-gray-900">
                        {item.name}
                      </h3>
                    </div>
                  </div>

                  <div className="tw-text-right">
                    <div className="tw-text-2xl tw-font-bold tw-text-blue-600 tw-text-nowrap">
                      от {parseInt(item.base_price).toLocaleString("ru-RU")} ₸
                    </div>
                    <div className="tw-text-sm tw-text-gray-500">в месяц</div>
                  </div>
                </label>

                {index === 2 && (
                  <div className="tw-absolute -tw-bottom-3 tw-left-1/2 tw-transform -tw-translate-x-1/2">
                    <span className="tw-bg-gradient-to-r tw-from-blue-500 tw-to-purple-600 tw-text-white tw-px-4 tw-py-1 tw-rounded-full tw-text-sm tw-font-semibold tw-shadow-lg">
                      Популярный
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Tariff Details */}
          <NewTariffDetail activeItem={activeItem} />
        </div>
      </div>
    </div>
  );
};

export default NewTariff;
